<template>
  <div>
    <h2 class="push-down push-up" v-html="content.InjuredCounterpartyTitle" />
    <p class="push-down" v-html="content.InjuredCounterpartyText" />
    <h2 v-html="content.InjuredCounterpartyHasContactInformationTitle" />
    <div class="control">
      <Field
        name="contact-information"
        v-slot="{ field, meta }"
        :rules="{ required: stepModel.ProductSpecific.InsuredCounterPartyFiled === null }"
        v-model="stepModel.ProductSpecific.InsuredCounterPartyFiled"
      >
        <RadioGroupStacked
          v-bind="field"
          :options="yesNoOptions"
          :model-value="stepModel.ProductSpecific.InsuredCounterPartyFiled"
        />

        <ValidationError
          :name="field.name"
          :overrides="{ required: 'Angiv venligst' }"
          v-if="meta.validated && !meta.valid"
        />
      </Field>
    </div>
    <div v-if="stepModel.ProductSpecific.InsuredCounterPartyFiled">
      <div class="control">
        <label
          for="injuredCounterparty-first-name"
          class="text-question"
          @input="emit"
          v-html="content.LabelInjuredCounterpartyFirstname"
        />

        <Field
          v-slot="{ field }"
          v-model="firstName"
          :rules="{ required: !valid }"
          name="injuredCounterparty-first-name"
        >
          <base-text-input v-bind="field" @input="emit" :errors="errors" />
        </Field>
      </div>
      <div class="control">
        <label
          for="injuredCounterparty-last-name"
          class="text-question"
          v-html="content.LabelInjuredCounterpartyLastname"
        />
        <Field
          v-slot="{ field }"
          v-model="lastName"
          :rules="{ required: !valid }"
          name="injuredCounterparty-last-name"
        >
          <base-text-input v-bind="field" @input="emit" :errors="errors" />
        </Field>
        
        <!-- Address Field --> 
        <div class="control">
          <label
            for="injuredCounterparty-address"
            class="text-question"
            v-html="content.LabelInjuredCounterpartyAddressSearch"
          />
            <address-search
              :model-value="selectedAddress"
              @update:model-value="(newValue) => { selectedAddress = newValue; emit(); }"
              name="injuredCounterparty-address"
            />
        </div>
      </div>
      <!-- Address Field End -->
      <div class="control row">
        <div class="small-12 medium-6 columns">
          <label for="injuredCounterparty-email" v-html="content.LabelInjuredCounterpartyEmail" />
          <Field
            v-slot="{ field }"
            v-model="email"
            :rules="{ required: !valid, email: true }"
            name="injuredCounterparty-email"
          >
            <base-text-input v-bind="field" @input="emit" :errors="errors" />
          </Field>
        </div>
        <div class="small-12 medium-6 columns">
          <label for="injuredCounterparty-phone" v-html="content.LabelInjuredCounterpartyPhone" />
          <Field
            v-slot="{ field }"
            v-model="phone"
            :rules="{ required: !valid, numeric: true, min: 8 }"
            name="injuredCounterparty-phone"
          >
            <base-text-input v-bind="field" maxlength="8" @input="emit" :errors="errors" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTextInput from '@/components/Forms/BaseTextInput.vue';
import AddressSearch from '@/components/UI/AddressSearch.vue';
import { isEmpty } from 'lodash';

export default {
  name: 'InjuredCounterparty',
  components: { BaseTextInput, AddressSearch },
  // inject: ['$validator'],
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    content: {
      type: Object,
      default() {
        return null;
      }
    },
    stepModel: {
      type: Object,
      default() {
        return null;
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      address: null,
      selectedAddress: null,
      yesNoOptions: [
        {
          Value: true,
          Label: 'Ja'
        },
        {
          Value: false,
          Label: 'Nej'
        }
      ]
    };
  },
  computed: {
    valid() {
        if (
          !isEmpty(this.firstName) &&
          this.errors['injuredCounterparty-first-name'] === undefined &&
          !isEmpty(this.lastName) &&
          this.errors['injuredCounterparty-last-name'] === undefined &&
          !isEmpty(this.phone) &&
          this.errors['injuredCounterparty-phone'] === undefined &&
          !isEmpty(this.email) &&
          this.errors['injuredCounterparty-email'] === undefined
        ) {
          return true;
      }
        
      return false;
    }
  },
  watch: {
    'stepModel.ProductSpecific.InsuredCounterPartyFiled': function (val) {
      if (!val) {
        this.reset();
      }
    }
  },
  mounted() {
    if (this.modelValue !== null) {
      this.firstName = this.modelValue.FirstName;
      this.lastName = this.modelValue.LastName;
      this.email = this.modelValue.Email;
      this.phone = this.modelValue.Phone;
      this.selectedAddress = this.modelValue.SelectedAddress;
    }
  },
  methods: {
    async emit() {
      await this.$nextTick();

      this.$emit('update:modelValue', {
        Id: null,
        FirstName: this.firstName,
        LastName: this.lastName,
        SelectedAddress: this.selectedAddress,
        Phone: this.phone,
        Email: this.email
      });
    },
    reset() {
      this.firstName = null;
      this.lastName = null;
      this.email = null;
      this.phone = null;
      this.selectedAddress = null;

      // TODO: REFACTOR LEGACY VALIDATOR
      // this.$validator.reset();

      this.$emit('update:modelValue', {
        Id: null,
        FirstName: null,
        LastName: null,
        SelectedAddress: null,
        Phone: null,
        Email: null
      });
    }
  }
};
</script>
